import React, { useContext } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import UserContext from "../context/UserContext";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  appBar: {
    boxShadow: "none",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginleft: drawerWidth,
  },
  hide: {
    display: "none",
  },
}));

function MyAppBar() {
  const classes = useStyles();
  const { OpenDrawer, State } = useContext(UserContext);

  return (
    <div>
      <AppBar
        color="transparent"
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: State.DrawerState,
        })}
      >
        <Toolbar style={{ paddingLeft: "35px" }}>
          <IconButton
            style={{ border: "solid white 0.1px" }}
            aria-label="open drawer"
            edge="start"
            className={clsx(State.DrawerState && classes.hide)}
            onClick={OpenDrawer}
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography variant="h6" noWrap>
            EdgarAnd
          </Typography>*/}
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default MyAppBar;
